import type { RouteRecordRaw } from 'vue-router'

export const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: ':id/notifications',
    name: 'corporative-notifications',
    component: () => import('@/modules/expert/notifications/views/List.vue'),

    props: true,
  },
]
